// modules
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonModule } from '../button/button.module';
import { IconModule } from '../icon/icon.module';

// imports
import { Pagination, PageEvent } from './pagination.component';

@NgModule({
  imports: [
    CommonModule,
    ButtonModule,
    IconModule,
  ],
  exports: [
    Pagination
  ],
  declarations: [
    Pagination
  ],
})
class PaginationModule { }

export { Pagination, PageEvent, PaginationModule };
